import { Grid } from "@mui/material";
import { InsightsCardSkeleton } from "../../components/Insights/InsightsAsyncState";
import KeyValueCard from "./design/KeyValueCard";
import {
  buildPricingReportSummaryCards,
  summaryCardGridMdSize,
} from "./pricingReportSummaryCardConfig";

export default function PricingReportQuarterlySummaryCards({
  quarterlySummaryStats,
  isQuarterlySummaryLoading,
  selectedProvince = null,
  selectedRetailers = [],
}) {
  const showInitialLoadingSkeletons =
    Boolean(isQuarterlySummaryLoading) && quarterlySummaryStats === undefined;

  const cards = buildPricingReportSummaryCards({
    quarterlySummaryStats,
    selectedProvince,
    selectedRetailers,
  });
  const gridMdSize = summaryCardGridMdSize(cards.length);

  return (
    <Grid container className="pricing-report-print-kpi-grid">
      {cards.map((card) => (
        <Grid key={card.key} item xs={12} sm={6} md={gridMdSize} sx={{ display: "flex" }}>
          {showInitialLoadingSkeletons ? (
            <InsightsCardSkeleton sx={{ flex: 1 }} />
          ) : (
            <KeyValueCard
              label={card.label}
              value={card.value}
              sx={{ width: "100%", flex: 1 }}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
}
